/**
 * Converts camelCase to kebab-case
 * Example: navBackground → nav-background
 */
export const camelToKebab = (str: string): string => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};
